<template>
  <v2-modal
    :show="show"
    title="Collection Warning"
    size="md"
    @close="$emit('close')"
  >
    <div
      class="v2-delete-collection-modal__body"
      v-html="message"
    />
    <template #footer>
      <template v-if="canDelete">
        <v2-button
          variant="outline"
          @click="$emit('close')"
        >
          Cancel
        </v2-button>
        <v2-button
          variant="destructive"
          :loading="isSaving"
          :disabled="isSaving"
          @click="$emit('confirm')"
        >
          Yes, remove the collection
        </v2-button>
      </template>
      <template v-else>
        <v2-button
          variant="primary"
          @click="$emit('close')"
        >
          Ok! I understand
        </v2-button>
      </template>
    </template>
  </v2-modal>
</template>

<script>
import V2Modal from '@/components/v2/V2Modal.vue'
import V2Button from '@/components/v2/V2Button.vue'

export default {
  name: 'V2DeleteCollectionModal',
  components: { V2Modal, V2Button },
  props: {
    show: { type: Boolean, default: false },
    message: { type: String, default: '' },
    canDelete: { type: Boolean, default: false },
    isSaving: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
.v2-delete-collection-modal__body {
  text-align: center;
  color: var(--v2-foreground);
  font-family: var(--v2-font-sans);
  font-size: 0.875rem;
  line-height: 1.6;
  padding: var(--v2-space-2) 0;
}
</style>
